"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const styles = {
    header: (0, react_1.css)({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgb(247, 247, 247);',
        boxShadow: 'rgb(255, 255, 255) 0px 1px 0px 0px inset',
    }),
};
function Header(props) {
    const { children, style: { leftStyle = {}, rightStyle = {}, containerStyle = {} } = {}, } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { css: (0, react_1.css)({ ...styles.header, ...containerStyle }), children: [(0, jsx_runtime_1.jsx)("div", { style: leftStyle, children: children[0] }), (0, jsx_runtime_1.jsx)("div", { style: rightStyle, children: children[1] })] }));
}
exports.Header = Header;
